import { Divider, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { logo } from "../../asset/Image";
import { useViewport } from "../../util/helper";
import { useTranslation } from "react-i18next";

const Sidebar = ({ role, key }) => {
  const navigate = useNavigate();
  const { width } = useViewport();
  const breakpoint = 1024;

  const { t, i18n } = useTranslation();

  const [current, setCurrent] = useState(key ?? "nomination_info");
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    let temp = [];
    temp.push({
      label: `${t("str_nomination_info")}`,
      key: "nomination_info",
      link: "/nomination/profile",
    });
    if (role?.type === "secretariat" || role?.type === "admin") {
      const index = temp.findIndex((x) => x.key === "close_nomination");
      if (index < 0) {
        temp.push({
          label: `${t("str_close_nomination")}`,
          key: "close_nomination",
          link: "/nomination/close-nomination",
        });
      }
    }
    if (role?.type === "secretariat" || role?.type === "admin") {
      const emailIndex = temp.findIndex((x) => x.key === "email_management");
      if (emailIndex < 0) {
        temp.push({
          label: `${t("str_email_management")}`,
          key: "email_management",
          link: "/nomination/email-management",
        });
      }
    }
    // temp.push({
    //   label: `${t("str_change_pass")}`,
    //   key: "change_password",
    //   link: "/change-password",
    // });

    setMenuItems([...temp]);
  }, [role, i18n.language]);

  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.item.props.link);
  };

  return (
    <div>
      <div className="brand-wrapper">
        <img src={logo} alt="brand" className="brand-logo" />
        {width < breakpoint ? (
          <span className="system-name">Nomination Management System</span>
        ) : (
          <span className="system-name">
            Nomination
            <br />
            Management
            <br />
            System
          </span>
        )}
      </div>
      <Divider />

      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode={width < breakpoint ? "horizontal" : "vertical"}
        items={menuItems}
      />
    </div>
  );
};

export default Sidebar;
